/* eslint-disable import/prefer-default-export */
/**
 * Option identifiers for the HomeAutoRenewalDate field (ContentfulCampaignFormFieldOption)
 */
export enum HomeAutoRenewalDateOption {
  Auto = 'AUTO',
  Home = 'HOME',
  Neither = 'NEITHER',
}
